export default {
  label: {
    rename: 'Renomear',
    duplicate: 'Duplicar',
    delete: 'Excluir',
  },
};
